import { ListItem, UnorderedList } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';

export const MembershipPerkList = () => {
    return (
        <UnorderedList className="membership-perk-list-container">
            <ListItem className="membership-perk-list-item">
                <FormattedMessage
                    id="membership-perk-list.deepen-connection"
                    defaultMessage="Deepen your community connection"
                />
            </ListItem>
            <ListItem className="membership-perk-list-item">
                <FormattedMessage
                    id="membership-perk-list.build-relationships"
                    defaultMessage="Build relationships with streamers"
                />
            </ListItem>
            <ListItem className="membership-perk-list-item">
                <FormattedMessage
                    id="membership-perk-list.vip"
                    defaultMessage="VIP community benefits"
                />
            </ListItem>
            <ListItem className="membership-perk-list-item">
                <FormattedMessage
                    id="membership-perk-list.unlock-rewards"
                    defaultMessage="Unlock exclusive bonuses and rewards"
                />
            </ListItem>
        </UnorderedList>
    );
};
